/** Color del indicador de estado de proveedores de IA / bots. 'disabled' es neutro (gris), no falla. */
export type DotColor = 'green' | 'yellow' | 'red' | 'gray';

export function statusDotColor(status: string): DotColor {
  if (status === 'ok')           return 'green';
  if (status === 'rate_limited') return 'yellow';
  if (status === 'no_credits')   return 'yellow';
  if (status === 'privacy_on')   return 'yellow';
  if (status === 'no_webhook')   return 'yellow';
  if (status === 'unconfigured' || status === 'disabled') return 'gray';
  return 'red';
}
